package validations

import model.LoginAltRequest

object LoginAltValidation {
    /** Would have been nice with regex but there is a bug in JS **/

    private val apartmentNumbers = Settings.apartments

    private fun validPhone(s: String) {
        if (s.length != 8) throw Exception("Invalid phone number: Should be 8 digits.")
        if (s.toIntOrNull() == null) throw Exception("Invalid phone number: Not a number")
    }

    private fun validApartmentNumber(s: String) {
        if (s !in apartmentNumbers) throw Exception("Invalid apartment number: Not an apartment in Calmeyers")
    }

    fun validate(request: LoginAltRequest) {
        validPhone(request.phoneNumber)
        if (request.firstName.isEmpty())
            throw Exception("Invalid first name")
        if (request.lastName.isEmpty())
            throw Exception("Invalid last name")
        validApartmentNumber(request.apartmentNumber)
    }
}